module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "flex flex-column items-center",
    class: {
      white: _vm.isWhite
    }
  }, _vm._l((_vm.content.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb1"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Page',
          params: {
            lang: _vm.lang,
            slug: item.slug
          }
        }
      }
    }, [_c('span', {
      staticClass: "pl1 pb1 pr3 border-btn border3 bold flex items-end",
      class: {
        'border-white': _vm.isWhite, 'border-accent': !_vm.isWhite
      }
    }, [_vm._v(_vm._s(item.title))])])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295291bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActionNav.vue
// module id = 120
// module chunks = 0